var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('a',{staticClass:"text-lowercase",on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v(" "+_vm._s(_vm.$t('auth.forgot_pass'))+" ")]),_c('ChangePasswordModal',{attrs:{"dialog":_vm.dialog},on:{"close":_vm.close}}),_c('NewPasswordModal',{on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }